<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="570px"
    :close-on-click-modal="false"
    @opened="creatQrCodes()"
    @closed="closedFnShow"
  >
    <div class="turnout-wrapper turnin-wrapper">
      <div class="qrcode qrcode-style" id="qrcodeimg" ref="qrCodeUrl">
        <img
          :hidden="!this.img"
          src="../assets/codelog.png"
          style="position: absolute;
    top: 206px;
    left: 166px;
    width: 100px;
}"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import QRCode from "qrcodejs2";
import date from "../../util/date";
export default {
  name: "Toolbar",
  data() {
    return {
      dialogVisible: false,
      qrcode: null,
      ads: "https://cn.vuejs.org/images/logo.png",
      img: false,
      msg:"qhsy"
    };
  },
  props: {
    isShowCodes: {
      default: false,
      type: Boolean,
    },
    Codesvalue: {
      default: "",
      type: String,
    },
    CodesvalueType: {
      default: 0,
      type: Number,
    },
  },
  watch: {
    isShowCodes(newValue) {
      this.dialogVisible = newValue;
      this.img = false;
    },
  },
  methods: {
    closedFnShow() {
      this.$emit("closedCodes");
      document
        .getElementsByClassName("qrcode")[0]
        .getElementsByTagName("img")[1]
        .remove();
    },
    creatQrCodes() {
      setTimeout(() => {
        console.log(date.formatDate.format(new Date(), "yyyy-MM-dd"));
        let obg = {
          data: this.Codesvalue,
          code: date.formatDate.format(new Date(), 'yyyy-MM-dd'),
          msg:this.msg
        };
        var jons = JSON.stringify(obg);
        console.log(jons);
        console.log(JSON.parse(jons));
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: JSON.stringify(obg), // 需要转换为二维码的内容
          width: 400,
          height: 400,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.img = true;
      }, 10);
    },
  },
};
</script>
<style>
#qrcodeimg > img {
  margin-left: 40px !important;
  padding: 20px 25px 50px !important;
}
</style>
